import React from 'react'
import { withTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import BackAnchor from 'shared/components/BackAnchor'
import ContinueCancelButtons from 'shared/components/ContinueCancelButtons'

const ScreeningQuestionNotSureView = ({ t, i18n }) => {
  const history = useHistory()

  const getPhoneNumber = (text) => {
    return `tel:${t(text)}`
  }

  const nsLocationsURL = i18n.language === 'en' ? 'https://novascotia.ca/access-locations/' : 'https://novascotia.ca/access-locations/fr/'

  const onContinueClick = () => {
    history.push(`/${i18n.language}${t('routes.address_type_change')}`)
  }

  return (
    <div className="container">
      <main>
        <article>
          <BackAnchor backPath='routes.screening_question' />
          <div className="row">
            <div className="col-xs-12">
              <h1>{t('screening_question_not_sure.you_should_call')}</h1>
              <p style={{ margin: 0 }}><strong>{t('screening_question_not_sure.registry_of_motor')}</strong></p>
              <p>{t('screening_question_not_sure.you_can_complete')}
                <a href={getPhoneNumber('screening_question_not_sure.number')}>{t('screening_question_not_sure.number')}</a>
                {t('screening_question_not_sure.or_in_person')}
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={nsLocationsURL}
                >
                  {' '}
                  {t('screening_question_not_sure.access_nova_scotia_location')}
                  <span className="ns-visually-hidden">{t('open_in_a_new_tab')}</span>
                </a>.
              </p>
            </div>
          </div>
          <ContinueCancelButtons continueClick={onContinueClick} />
        </article>
      </main >
    </div >
  )
}

export default withTranslation('common')(ScreeningQuestionNotSureView)
